import '@qpokychuk/sf-pro-display/index.css'
import '@qpokychuk/sf-pro-display/italic.css'
import '@qpokychuk/sf-pro-display/normal.css'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useParams } from 'react-router-dom'
import RpContainer from './components/RpContainer'
import { RussianPokerStoreProvider } from './providers/RussianPokerStoreProvider'
import { SocketProvider } from './providers/SocketProvider'

const ManageGameRussianPoker: FC = observer(() => {
  const { gameId } = useParams<{ gameId: string }>()

  if (!gameId) {
    return <div>Game ID is required</div>
  }

  return (
    <RussianPokerStoreProvider gameId={gameId}>
      <SocketProvider>
        <RpContainer />
      </SocketProvider>
    </RussianPokerStoreProvider>
  )
})

export default ManageGameRussianPoker
